module.exports = __webpack_public_path__ + "static/img/release-forward.e5a723c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/release-forward.png
// module id = wjnS
// module chunks = 36